import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContactEndpoint } from './contact-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ContactRoutingResolver
  
{
  constructor(private http: HttpClient, private router: Router) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.http.get(route.data.dataUrl).pipe(
      catchError((err) => {
        console.error(err);
        this.router.navigate(['/']);
        return EMPTY;
      })
    );
  }
}
